"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFilterGroups = exports.getPersistedFiltersMaps = exports.getPersistedPresetsMap = exports.getFilterPresetsRaw = exports.getActiveFiltersParamString = exports.getPresetFiltersParamString = exports.getPresetFiltersParamArray = exports.getSelectedFiltersParamString = exports.getSelectedFiltersParamArray = exports.getFilterDTOsByIds = exports.getEntriesFromMapByIds = exports.getAllActiveFiltersMap = exports.getSelectedFiltersMap = exports.getPresetFiltersMap = exports.getFilterDTOsMap = exports.getFilterItemsMap = exports.filterItemsArrayToMap = exports.getFilterItemsRaw = exports.getFilterOptionsState = void 0;
const filter_dto_1 = require("../utils/filter-dto");
const getFilterOptionsState = (state = {}) => state.filterOptions || {};
exports.getFilterOptionsState = getFilterOptionsState;
const getFilterItemsRaw = (state = {}) => state.filters || [];
exports.getFilterItemsRaw = getFilterItemsRaw;
const filterItemsArrayToMap = (filtersArray_ = []) => new Map(filtersArray_.map((filter) => [filter.id, new filter_dto_1.default(filter)]));
exports.filterItemsArrayToMap = filterItemsArrayToMap;
const getFilterItemsMap = (state = {}) => new Map((0, exports.getFilterItemsRaw)(state).map((item) => [item.id, item]));
exports.getFilterItemsMap = getFilterItemsMap;
const getFilterDTOsMap = (state = {}) => (0, exports.filterItemsArrayToMap)((0, exports.getFilterItemsRaw)(state));
exports.getFilterDTOsMap = getFilterDTOsMap;
const getPresetFiltersMap = (state = {}) => {
    const filtersMap = (0, exports.getFilterDTOsMap)(state);
    const presetFilterDTOs = new Map();
    for (const [filterId, filterDTO] of filtersMap.entries()) {
        if (filterDTO.isPreset()) {
            presetFilterDTOs.set(filterDTO.id, filtersMap.get(filterId));
        }
    }
    return presetFilterDTOs;
};
exports.getPresetFiltersMap = getPresetFiltersMap;
const getSelectedFiltersMap = (state = {}) => {
    const filtersMap = (0, exports.getFilterDTOsMap)(state);
    const selectedFilterDTOs = new Map();
    for (const [filterId, filterDTO] of filtersMap.entries()) {
        if (filterDTO.isActive() && !filterDTO.isPreset()) {
            selectedFilterDTOs.set(filterDTO.id, filtersMap.get(filterId));
        }
    }
    return selectedFilterDTOs;
};
exports.getSelectedFiltersMap = getSelectedFiltersMap;
const getAllActiveFiltersMap = (state = {}) => {
    const filtersMap = (0, exports.getFilterDTOsMap)(state);
    const activeFilterDTos = new Map();
    for (const [filterId, filterDTO] of filtersMap.entries()) {
        if (filterDTO.isPreset() || filterDTO.isActive()) {
            activeFilterDTos.set(filterDTO.id, filtersMap.get(filterId));
        }
    }
    return activeFilterDTos;
};
exports.getAllActiveFiltersMap = getAllActiveFiltersMap;
const getEntriesFromMapByIds = (ids = [], map = new Map()) => {
    const returnMap = new Map();
    ids.forEach((id) => {
        if (map.has(id)) {
            returnMap.set(id, map.get(id));
        }
    });
    return returnMap;
};
exports.getEntriesFromMapByIds = getEntriesFromMapByIds;
const getFilterDTOsByIds = (state, filterIds = []) => {
    const allFilterDTOsMap = (0, exports.getFilterDTOsMap)(state);
    return (0, exports.getEntriesFromMapByIds)(filterIds, allFilterDTOsMap);
};
exports.getFilterDTOsByIds = getFilterDTOsByIds;
const getSelectedFiltersParamArray = (state = {}) => [...(0, exports.getSelectedFiltersMap)(state).values()].map((filterDTO) => filterDTO.toString());
exports.getSelectedFiltersParamArray = getSelectedFiltersParamArray;
const getSelectedFiltersParamString = (state = {}) => (0, exports.getSelectedFiltersParamArray)(state).join(',');
exports.getSelectedFiltersParamString = getSelectedFiltersParamString;
const getPresetFiltersParamArray = (state = {}) => [...(0, exports.getPresetFiltersMap)(state).values()].map((filterDTO) => filterDTO.toString());
exports.getPresetFiltersParamArray = getPresetFiltersParamArray;
const getPresetFiltersParamString = (state = {}) => (0, exports.getPresetFiltersParamArray)(state).join(',');
exports.getPresetFiltersParamString = getPresetFiltersParamString;
const getActiveFiltersParamString = (state = {}) => [...(0, exports.getAllActiveFiltersMap)(state).values()].map((filterDTO) => filterDTO.toString()).join(',');
exports.getActiveFiltersParamString = getActiveFiltersParamString;
const getFilterPresetsRaw = (state) => state.filterParams || { preset: [], filter: [] };
exports.getFilterPresetsRaw = getFilterPresetsRaw;
const getPersistedPresetsMap = (state = {}) => new Map((0, exports.getFilterPresetsRaw)(state).preset.map((filter) => {
    const filterDTO = filter_dto_1.default.initFromFilterString(filter);
    return [filterDTO.id, filterDTO];
}));
exports.getPersistedPresetsMap = getPersistedPresetsMap;
const getPersistedFiltersMaps = (state = {}) => new Map((0, exports.getFilterPresetsRaw)(state).filter.map((filter) => {
    const filterDTO = filter_dto_1.default.initFromFilterString(filter);
    return [filterDTO.id, filterDTO];
}));
exports.getPersistedFiltersMaps = getPersistedFiltersMaps;
const getFilterGroups = (state) => state.filterGroups || {};
exports.getFilterGroups = getFilterGroups;
//# sourceMappingURL=filters.js.map